import React, { useState, useEffect } from 'react';
import { supabase } from '../supabase';

const MOCK_CREW = [
  { id: 1, name: 'Tyler Kehrig', role: 'Lead Operator', site: 'Swift Current', rate: 32.00, days: 14, regHours: 140, otHours: 28 },
  { id: 2, name: 'Jordan Parr', role: 'Operator', site: 'Melville', rate: 28.00, days: 14, regHours: 140, otHours: 22 },
  { id: 3, name: 'Mike Brandt', role: 'Mechanic', site: 'Swift Current', rate: 35.00, days: 12, regHours: 120, otHours: 18 },
  { id: 4, name: 'Dustin Rempel', role: 'Truck Driver', site: 'Swift Current', rate: 26.00, days: 14, regHours: 140, otHours: 32 },
  { id: 5, name: 'Cole Fehr', role: 'Operator', site: 'Melville', rate: 28.00, days: 13, regHours: 130, otHours: 16 },
  { id: 6, name: 'Brett Makofka', role: 'Operator', site: 'Swift Current', rate: 28.00, days: 14, regHours: 140, otHours: 20 },
  { id: 7, name: 'Travis Hunt', role: 'Tender Operator', site: 'Swift Current', rate: 25.00, days: 11, regHours: 110, otHours: 8 },
  { id: 8, name: 'Kyle Makofka', role: 'Operator', site: 'Melville', rate: 27.00, days: 14, regHours: 140, otHours: 24 },
];
var OT_MULT = 1.5;

export default function PayrollPage() {
  const [crew] = useState(MOCK_CREW);
  const [payPeriod] = useState('May 1 - May 14, 2025');
  const [generated, setGenerated] = useState(false);
  const [generating, setGenerating] = useState(false);
  useEffect(function() { /* Future: fetch crew logs from supabase */ }, []);

  var calcGross = function(m) { return (m.regHours * m.rate) + (m.otHours * m.rate * OT_MULT); };
  var totalReg = crew.reduce(function(s,m){return s+m.regHours;},0);
  var totalOT = crew.reduce(function(s,m){return s+m.otHours;},0);
  var totalGross = crew.reduce(function(s,m){return s+calcGross(m);},0);
  var totalDays = crew.reduce(function(s,m){return s+m.days;},0);
  var fmt = function(n) { return '$' + n.toLocaleString('en-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };

  var handleGenerate = function() {
    setGenerating(true);
    setTimeout(function() { setGenerating(false); setGenerated(true); }, 1500);
  };

  return (
    <div className="page-container">
      <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem', flexWrap: 'wrap', gap: '1rem' }}>
        <div>
          <h1 style={{ margin: 0, color: 'var(--text)' }}>Payroll</h1>
          <p style={{ margin: '4px 0 0', color: 'var(--text-secondary)', fontSize: '0.9rem' }}>Auto-generated from crew daily logs - {payPeriod}</p>
        </div>
        <button className="btn btn-primary" onClick={handleGenerate} disabled={generating} style={{ background: generating ? '#555' : 'var(--primary)', color: '#fff', border: 'none', padding: '1rem 2.5rem', borderRadius: '12px', fontWeight: 700, cursor: generating ? 'wait' : 'pointer', fontSize: '1.1rem', boxShadow: generating ? 'none' : '0 4px 15px rgba(54,124,43,0.4)' }}>
          {generating ? 'Generating...' : generated ? 'Regenerate Payroll' : 'Generate Payroll'}
        </button>
      </div>

      <div className="stats-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '1rem', marginBottom: '1.5rem' }}>
        {[{l:'Total Gross',v:fmt(totalGross),c:'var(--primary)'},{l:'Crew Members',v:crew.length,c:'var(--primary)'},{l:'Total Reg Hours',v:totalReg.toLocaleString(),c:'var(--text)'},{l:'Total OT Hours',v:totalOT.toLocaleString(),c:'#f59e0b'}].map(function(s){
          return <div key={s.l} className="stat-card" style={{ background: 'var(--surface)', borderRadius: '12px', padding: '1.25rem', textAlign: 'center' }}><div style={{ color: 'var(--text-secondary)', fontSize: '0.85rem', marginBottom: '0.25rem' }}>{s.l}</div><div style={{ color: s.c, fontSize: '2rem', fontWeight: 700 }}>{s.v}</div></div>;
        })}
      </div>

      {!generated && !generating && (
        <div className="card" style={{ padding: '4rem 2rem', textAlign: 'center', background: 'var(--surface)', borderRadius: '12px' }}>
          <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>&#128176;</div>
          <h2 style={{ color: 'var(--text)', marginBottom: '0.5rem' }}>Ready to Generate Payroll</h2>
          <p style={{ color: 'var(--text-secondary)', maxWidth: '500px', margin: '0 auto 1.5rem', lineHeight: 1.6 }}>Click the big green button above. CropPatrol pulls hours from crew daily logs automatically. No spreadsheets, no manual entry.</p>
          <p style={{ color: 'var(--text-secondary)', fontSize: '0.85rem' }}>Pay period: <strong style={{ color: 'var(--primary)' }}>{payPeriod}</strong> | {crew.length} crew | OT: {OT_MULT}x after 10 hrs/day</p>
        </div>
      )}

      {generating && (
        <div className="card" style={{ padding: '4rem 2rem', textAlign: 'center', background: 'var(--surface)', borderRadius: '12px' }}>
          <div style={{ fontSize: '2rem', marginBottom: '1rem' }}>&#9881;</div>
          <h2 style={{ color: 'var(--primary)' }}>Generating Payroll...</h2>
          <p style={{ color: 'var(--text-secondary)' }}>Pulling hours from crew logs and calculating pay...</p>
        </div>
      )}

      {generated && (
        <div className="card" style={{ background: 'var(--surface)', borderRadius: '12px', overflow: 'hidden' }}>
          <div style={{ padding: '1.25rem 1.5rem', borderBottom: '1px solid var(--border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h3 style={{ margin: 0, color: 'var(--text)' }}>Payroll Summary - {payPeriod}</h3>
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <button style={{ background: 'transparent', color: 'var(--primary)', border: '1px solid var(--primary)', padding: '0.4rem 1rem', borderRadius: '8px', cursor: 'pointer', fontSize: '0.85rem' }}>Export CSV</button>
              <button style={{ background: 'transparent', color: 'var(--text)', border: '1px solid var(--border)', padding: '0.4rem 1rem', borderRadius: '8px', cursor: 'pointer', fontSize: '0.85rem' }}>Print</button>
            </div>
          </div>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead><tr style={{ borderBottom: '2px solid var(--border)' }}>
                {['Name','Role','Site','Days','Reg Hrs','OT Hrs','Rate','Gross Pay'].map(function(h){ return <th key={h} style={{ padding: '0.75rem 1rem', textAlign: 'left', color: 'var(--text-secondary)', fontSize: '0.8rem', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em' }}>{h}</th>; })}
              </tr></thead>
              <tbody>
                {crew.map(function(m) {
                  return (
                    <tr key={m.id} style={{ borderBottom: '1px solid var(--border-light)' }}>
                      <td style={{ padding: '0.75rem 1rem', color: 'var(--text)', fontWeight: 600 }}>{m.name}</td>
                      <td style={{ padding: '0.75rem 1rem', color: 'var(--text-secondary)' }}>{m.role}</td>
                      <td style={{ padding: '0.75rem 1rem', color: 'var(--text-secondary)' }}>{m.site}</td>
                      <td style={{ padding: '0.75rem 1rem', color: 'var(--text)' }}>{m.days}</td>
                      <td style={{ padding: '0.75rem 1rem', color: 'var(--text)' }}>{m.regHours}</td>
                      <td style={{ padding: '0.75rem 1rem', color: m.otHours > 20 ? '#f59e0b' : 'var(--text)' }}>{m.otHours}</td>
                      <td style={{ padding: '0.75rem 1rem', color: 'var(--text)' }}>{fmt(m.rate)}/hr</td>
                      <td style={{ padding: '0.75rem 1rem', color: 'var(--primary)', fontWeight: 700, fontSize: '1.05rem' }}>{fmt(calcGross(m))}</td>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot><tr style={{ borderTop: '2px solid var(--primary)', background: 'var(--bg)' }}>
                <td colSpan={3} style={{ padding: '0.85rem 1rem', color: 'var(--primary)', fontWeight: 700, fontSize: '1rem' }}>TOTALS</td>
                <td style={{ padding: '0.85rem 1rem', color: 'var(--primary)', fontWeight: 700 }}>{totalDays}</td>
                <td style={{ padding: '0.85rem 1rem', color: 'var(--primary)', fontWeight: 700 }}>{totalReg}</td>
                <td style={{ padding: '0.85rem 1rem', color: 'var(--primary)', fontWeight: 700 }}>{totalOT}</td>
                <td style={{ padding: '0.85rem 1rem', color: 'var(--text-secondary)' }}>-</td>
                <td style={{ padding: '0.85rem 1rem', color: 'var(--primary)', fontWeight: 700, fontSize: '1.2rem' }}>{fmt(totalGross)}</td>
              </tr></tfoot>
            </table>
          </div>
          <div style={{ padding: '1rem 1.5rem', borderTop: '1px solid var(--border)', display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: '0.5rem' }}>
            <span style={{ color: 'var(--text-secondary)', fontSize: '0.85rem' }}>Auto-calculated from crew daily logs. OT = time-and-a-half after 10 hrs/day.</span>
            <span style={{ color: 'var(--primary)', fontSize: '0.85rem', fontWeight: 600 }}>Avg cost/crew/day: {fmt(totalGross / totalDays)}</span>
          </div>
        </div>
      )}
    </div>
  );
}